{
    "raporrandevu": {
        "Baslik": "Appointment Report",
        "Tarih": "Date",
        "Kullanici": "User",
        "Musteri": "Customer",
        "Sonuc": "Result",
        "Gorusme": "Meeting",
        "Aciklama": "Description",
        "Saat": "Hour",
        "Arama": "Search",
        "Ara": "Search",
        "Kapat": "Close",
        "Temizle": "Clear",
        "BaslangicTarihi": "Start Date",
        "BitisTarihi": "End Date",
        "BasSaat": "Start Time",
        "BitSaat": "End Time",
        "TGorusme": "Total Meeting",
        "Ulasim": "Transport",
        "Not": "Note",
        "Gorusme1": "First Meeting",
        "Gorusme2": "2nd Meeting",
        "Arac": "Vehicle",
        "Diger": "Other",
        "OjtVar": "OJT Exists",
        "OjtYok": "No OJT",
        "Harita": "Map",
        "Duzenle": "Edit",
        "Sil": "Delete",
        "EminMisiniz": "Are you sure?",
        "GeriAlamazsiniz": "You won't be able to revert this!",
        "EvetSil": "Yes, delete it!",
        "Iptal": "Cancel",
        "OjtBaslik": "On The Jobtraining",
        "OjtDegerlendirme": "Evaluation",
        "OjtOlustur": "Yes, create!",
        "Sayfa": "Page",
        "RandevuDetayi": "Appointment Detail",
        "Katilanlar": "Attendees",
        "GecmisRandevular": "Past Appointments",
        "Konum": "Location",
        "Vazgec": "Cancel",
        "Bilgisi": "Information",
        "EskiRandevular": "Past Appt.",
        "BaslamaSaat": "Start Time",
        "BitisSaat": "End Time",
        "GorusmeSonucu": "Meeting Result",
        "SonIslemYapan": "Last Modified By",
        "SonGuncelleme": "Last Updated",
        "Guncelle": "Update",
        "SaatKontrol": "Time Check",
        "Katilan": "Attendee",
        "Durum": "Status",
        "Onay": "Approval",
        "Onayladi": "Approved",
        "Onaylamadi": "Not Approved",
        "Kapsam": "Scope",
        "Kendi": "Own",
        "Takim": "Team",
        "Sube": "Branch",
        "Tam": "Full",
        "HedeflenenRandevular": "Targeted Appointments",
        "Islemler": "Actions",
        "OjtOlusurmaTooltip": "Create On The Jobtraining",
        "HaritaTooltip": "Map",
        "GoruntuleTooltip": "View",
        "SilTooltip": "Delete",
        "SilmeOnayMetni": "This action cannot be undone. Are you sure you want to permanently delete the record?",
        "Excel": "Excel",
        "Ojt": "OJT"
    }
}
